import { IOneStoreConciliation } from "@/@types/store-conciliation";
import { StatusEnumStoreConciliation } from "@/enum/statusConciliation";
import { StatusHistoryContent } from "../conciliation-status-modal";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { Button } from "@/components/ui/button";
import { History } from "lucide-react";

interface ProcessingInfoProps {
  conciliation: IOneStoreConciliation | undefined;
  processingDate: string;
}

export function ProcessingInfo({ conciliation, processingDate }: ProcessingInfoProps) {
  const { handleModal } = useDialogModal();

  return (
    <div className="text-sm flex flex-col gap-1">
      <div className="flex flex-wrap items-center gap-1">
        <span className="font-medium">Último processamento:</span>
        <span className="italic">{processingDate}</span>
        {conciliation?.last_processing_by && (
          <span>| por {conciliation.last_processing_by}</span>
        )}
      </div>

      {(conciliation?.status_history?.length && (
        <div className="flex flex-wrap items-center gap-1">
          {(() => {
            const last = conciliation.status_history.at(-1);
            if (!last) return null;

            const statusText =
              last.status === StatusEnumStoreConciliation.OPENED
                ? "Aberto"
                : "Fechado";
            const date = new Date(last.created_at).toLocaleString(
              "pt-BR",
              {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              }
            );

            return (
              <>
                <span className="font-medium">Última Ação:</span>
                <span>{statusText}</span>
                <span>| por {last.changed_by}</span>
                <span>| {date}</span>
              </>
            );
          })()}
          {conciliation?.status_history && conciliation.status_history.length > 0 && (
            <Button
              variant="outline"
              size="sm"
              className="ml-2 border-none underline"
              onClick={() =>
                handleModal({
                  isOpen: true,
                  title: "Histórico de Status",
                  element: (
                    <StatusHistoryContent
                      statusHistory={conciliation.status_history ?? []}
                    />
                  ),
                })
              }
            >
              <History className="mr-2 h-4 w-4" /> Histórico
            </Button>
          )}
        </div>
      )) ||
        ""}
    </div>
  );
}
